<template>
    <footer class="site-footer">
        <div class="site-footer__inner">
            <div class="site-footer__col site-footer__brand">
                <router-link :to="{ name: 'News' }" class="site-footer__logo">
                    <img :src="require('@/assets/main_logo.png')" alt="BIG">
                    <span>BIG Basketball</span>
                </router-link>
                <p class="site-footer__about">
                    Νέα, πρόγραμμα, βαθμολογίες και στατιστικά της διοργάνωσης Back in the Game.
                </p>
                <div class="site-footer__label">Ακολούθησέ μας</div>
                <div class="site-footer__social">
                    <button type="button" aria-label="Facebook" @click="openSocial('facebook')"><v-icon class="custom-orange-text">mdi-facebook</v-icon></button>
                    <button type="button" aria-label="Instagram" @click="openSocial('instagram')"><v-icon class="custom-orange-text">mdi-instagram</v-icon></button>
                    <button type="button" aria-label="YouTube" @click="openSocial('youtube')"><v-icon class="custom-orange-text">mdi-youtube</v-icon></button>
                    <button type="button" aria-label="TikTok" @click="openSocial('tiktok')">
                        <span class="tiktok-icon" :style="tiktokMask" />
                    </button>
                </div>
            </div>

            <nav class="site-footer__col">
                <div class="site-footer__title">Σελίδες</div>
                <router-link v-for="link in pageLinks" :key="link.name" :to="{ name: link.name }" class="site-footer__link">
                    {{ link.text }}
                </router-link>
            </nav>

            <nav class="site-footer__col">
                <div class="site-footer__title">Διοργάνωση</div>
                <router-link v-for="link in organizationLinks" :key="link.name" :to="{ name: link.name }" class="site-footer__link">
                    {{ link.text }}
                </router-link>
            </nav>

            <div class="site-footer__col">
                <div class="site-footer__title">Κατέβασε την εφαρμογή</div>
                <div class="site-footer__stores">
                    <img :src="require('@/assets/google_play.png')" alt="Google Play" @click="openSocial('google_play')">
                    <img :src="require('@/assets/app_store.png')" alt="App Store" @click="openSocial('app_store')">
                </div>
                <div class="site-footer__title site-footer__title--spaced">Επικοινωνία</div>
                <div v-for="contact in contacts" :key="contact.email" class="site-footer__person">
                    <a :href="`tel:${contact.phone}`" class="site-footer__link site-footer__contact">
                        <v-icon small>mdi-phone</v-icon>
                        {{ contact.phoneLabel }}
                    </a>
                    <a :href="`mailto:${contact.email}`" class="site-footer__link site-footer__contact">
                        <v-icon small>mdi-email-outline</v-icon>
                        {{ contact.email }}
                    </a>
                </div>
            </div>
        </div>

        <div class="site-footer__bottom">
            <span>© {{ year }} BIG Basketball</span>
            <router-link :to="{ name: 'PrivacyPolicy' }" class="site-footer__link">Πολιτική Απορρήτου</router-link>
        </div>
    </footer>
</template>

<script>
    const SOCIAL_LINKS = {
        facebook: 'https://www.facebook.com/backinthegamegr',
        instagram: 'https://www.instagram.com/backinthegame_2012/',
        youtube: 'https://www.youtube.com/@BackIntheGameBasketball',
        tiktok: 'https://www.tiktok.com/@backinthegame2012',
        google_play: 'https://play.google.com/store/apps/details?id=com.vue.big.app',
        app_store: 'https://apps.apple.com/us/app/b-i-g/id6748522198'
    }

    // Inline, so the relative asset url resolves against the page and not the built css/ folder
    const TIKTOK_URL = `url(${require('@/assets/tiktok.svg')})`
    const TIKTOK_MASK = { maskImage: TIKTOK_URL, webkitMaskImage: TIKTOK_URL }

    // Desktop footer (on mobile the same links live in the app menu)
    export default {
        data() {
            return {
                year: new Date().getFullYear(),
                tiktokMask: TIKTOK_MASK,
                // same people as the contact page
                contacts: [
                    { phone: '+306979575906', phoneLabel: '+30 697 957 5906', email: 'ivalmas@backinthegame.gr' },
                    { phone: '+306979607540', phoneLabel: '+30 697 960 7540', email: 'gvalmas@backinthegame.gr' }
                ],
                pageLinks: [
                    { text: 'Νέα', name: 'News' },
                    { text: 'Βαθμολογία', name: 'Standings' },
                    { text: 'Πρόγραμμα', name: 'Schedule' },
                    { text: 'Ομάδες', name: 'Teams' },
                    { text: 'Στατιστικά', name: 'Stats' },
                    { text: 'Γήπεδα', name: 'Courts' }
                ],
                organizationLinks: [
                    { text: 'Εγγραφή ομάδας', name: 'Register' },
                    { text: 'Κανονισμός', name: 'Regulations' },
                    { text: 'Ποινές', name: 'Penalties' },
                    { text: 'Free Agents', name: 'FreeAgents' },
                    { text: 'Φιλοσοφία', name: 'Philosophy' },
                    { text: 'Επικοινωνία', name: 'ContactUs' }
                ]
            }
        },
        methods: {
            openSocial(social) {
                if (SOCIAL_LINKS[social]) {
                    window.open(SOCIAL_LINKS[social], '_blank')
                }
            }
        }
    }
</script>

<style scoped>
.site-footer {
    position: relative;
    z-index: 100;
    margin-top: 48px;
    background: #fff;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
    color: rgba(0, 0, 0, 0.7);
    font-family: Ubuntu, Arial, sans-serif;
    text-align: left;
}

.site-footer::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #ef4444 0%, #ff7133 50%, orange 100%);
}

.site-footer__inner {
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr 1.3fr;
    gap: 32px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 44px 24px 28px;
}

.site-footer__logo {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: #2b2b2e !important;
    font-family: Mansalva, Arial, sans-serif;
    font-size: 1.4rem;
    text-decoration: none;
}

.site-footer__logo img {
    width: 48px;
    height: 48px;
    object-fit: contain;
}

.site-footer__about {
    max-width: 300px;
    margin: 12px 0 18px;
    font-size: 0.88rem;
    line-height: 1.6;
}

.site-footer__title,
.site-footer__label {
    margin-bottom: 12px;
    color: #2b2b2e;
    font-size: 0.78rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.site-footer__label {
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 0.5);
}

.site-footer__title--spaced {
    margin-top: 22px;
}

.site-footer__col {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.site-footer__link {
    padding: 4px 0;
    color: rgba(0, 0, 0, 0.68) !important;
    font-size: 0.9rem;
    text-decoration: none;
    transition: color 0.15s ease;
}

.site-footer__link:hover {
    color: #ef4444 !important;
}

.site-footer__person {
    display: flex;
    flex-direction: column;
}

.site-footer__person + .site-footer__person {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.site-footer__contact {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.site-footer__contact .v-icon {
    color: #ff7133 !important;
}

.site-footer__social {
    display: flex;
    gap: 10px;
}

.site-footer__social button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #f4f4f6;
    transition: background 0.15s ease;
}

.site-footer__social button:hover {
    background: #fff3ec;
}

/* TikTok is an svg: used as a mask over the custom-orange gradient, so it matches the font icons.
   The mask url is set inline (tiktokMask): a url() inside a custom property resolves against the
   built css/ folder, which broke the relative asset path in production */
.tiktok-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: linear-gradient(90deg, #ef4444 0%, #ff7133 70%, orange 100%);
    mask-position: center;
    mask-size: contain;
    mask-repeat: no-repeat;
    /* stylelint-disable property-no-vendor-prefix -- Safari and the Android webviews of the app still need the prefix */
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    /* stylelint-enable property-no-vendor-prefix */
}

.site-footer__stores {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.site-footer__stores img {
    width: 140px;
    height: auto;
    cursor: pointer;
    transition: transform 0.15s ease;
}

.site-footer__stores img:hover {
    transform: translateY(-2px);
}

.site-footer__bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    padding: 16px 24px 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    color: rgba(0, 0, 0, 0.5);
    font-size: 0.82rem;
}

@media (max-width: 1100px) {
    .site-footer__inner {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
</style>
